/**
 * Версия программы и дата её сборки.
 *
 * Значения подставляются при сборке (см. `define` в `vite.config.ts`): номер
 * берётся из `package.json`, дата — из дня сборки. В исходниках их нет
 * намеренно — иначе пришлось бы помнить про второе место при каждом выпуске,
 * и однажды показанная версия разошлась бы с настоящей.
 *
 * Запасные значения нужны для тестов и режима разработки, где `define` не
 * отрабатывает: там важно, чтобы экран не падал, а не какой именно номер.
 */

declare const __ВЕРСИЯ__: string | undefined;
declare const __ДАТА_СБОРКИ__: string | undefined;

export const ВЕРСИЯ: string = typeof __ВЕРСИЯ__ === 'string' ? __ВЕРСИЯ__ : '—';
export const ДАТА_СБОРКИ: string = typeof __ДАТА_СБОРКИ__ === 'string' ? __ДАТА_СБОРКИ__ : '';
